import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateDisplayRecord } from "../shared/DateDisplayRecord";
import { TimespanDisplayRecord } from "../shared/TimespanDisplayRecord";

export const InspectorMarkerRecord = Record({
  // Normal properties of Calendar Marker
  id: "",
  label: "",
  // Named Color ID, or swatch color (both acceptable)
  color: "",
  // Swatch Color
  swatchColor: "",
  icon: "",
  drawOnTimeline: false,
  startDate: DateDisplayRecord(),
  endDate: DateDisplayRecord(),
  duration: TimespanDisplayRecord(),
  repeat: false,
  repeatFrequency: TimespanDisplayRecord(),
  repeatUntil: DateDisplayRecord()
});

const data = {
  objects: {
    startDate: "DateDisplayRecord",
    endDate: "DateDisplayRecord",
    repeatUntil: "DateDisplayRecord",
    duration: "TimespanDisplayRecord",
    repeatFrequency: "TimespanDisplayRecord"
  }
};
createFromJS.registerCallback("InspectorMarkerRecord", createFromJS.createNestedCallback(InspectorMarkerRecord, data));
